import React from "react";

export const TrackContext = React.createContext({ activeTrackIndex: 0 });

export const TrackProvider = ({ children, data }) => {
  const tracks = data.tracks;
  const trackIds = Object.keys(tracks);
  const [activeTrackIndex, setActiveTrackIndex] = React.useState(0);
  const [activeTrackId, setActiveTrackId] = React.useState(tracks[trackIds[0]]);

  const updateActiveTrackIndex = index => {
    setActiveTrackIndex(index);
  };

  return (
    <TrackContext.Provider
      value={{
        tracks,
        trackIds,
        activeTrackIndex,
        updateActiveTrackIndex,
        activeTrackId,
        setActiveTrackId
      }}
    >
      {children}
    </TrackContext.Provider>
  );
};
